if (!customElements.get('coirology-faq')) {
  customElements.define('coirology-faq', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.input = this.querySelector('input[type="search"]');
      this.clear = this.querySelector('[data-clear]');
      this.results = this.querySelector('[data-results]');
      this.empty = this.querySelector('[data-empty]');
      this.answers = [...this.querySelectorAll('[data-answer]')];
      this.groups = [...this.querySelectorAll('[data-group]')];
      this.initial = new Map(this.answers.map(answer => [answer, answer.open]));
      this.searchText = new Map(this.answers.map(answer => [answer, answer.textContent.toLocaleLowerCase().replace(/\s+/g, ' ')]));
      this.querySelector('.cfq-search').hidden = false;
      this.querySelector('[data-hint]').hidden = false;
      this.input.addEventListener('input', () => this.filter());
      this.input.addEventListener('keydown', event => {
        if (event.key === 'Escape') { this.input.value = ''; this.filter(); }
      });
      this.clear.addEventListener('click', () => { this.input.value = ''; this.filter(); this.input.focus(); });
      this.querySelectorAll('[data-topic-link]').forEach(link => link.addEventListener('click', () => {
        if (this.input.value) { this.input.value = ''; this.filter(); }
      }));
      this.addEventListener('shopify:block:select', event => {
        const answer = event.target.closest('[data-answer]');
        if (answer) { this.input.value = ''; this.filter(); answer.open = true; }
      });
    }
    filter() {
      const query = this.input.value.trim().toLocaleLowerCase();
      const words = query.split(/\s+/).filter(Boolean);
      let count = 0;
      this.answers.forEach(answer => {
        const matches = words.every(word => this.searchText.get(answer).includes(word));
        answer.hidden = !matches;
        answer.open = query ? matches : this.initial.get(answer);
        if (matches) count++;
      });
      this.groups.forEach(group => { group.hidden = ![...group.querySelectorAll('[data-answer]')].some(answer => !answer.hidden); });
      this.clear.hidden = !query;
      this.empty.hidden = !query || count > 0;
      this.results.textContent = query ? `${this.dataset.resultsLabel}: ${count}` : '';
    }
  });
}
